export const UNITS_SIZE = [
    'Bytes',
    'KiBytes',
    'MiBytes',
    'GiBytes',
    'TiBytes',
    'PiBytes',
];
